export default __webpack_public_path__ + "static/home-man-67421e8594dfed893405f5a8a9e08c0b.webp";